var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher-wrapper"},[_c('LanguageSwitcherList',{staticClass:"list",attrs:{"center":""}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }